import React from 'react';
import clsx from 'clsx';
import styles from './styles.css.js';
import ItemsList from '../items-list';
var CategoryElement = function (_a) {
    var _b;
    var item = _a.item, onItemActivate = _a.onItemActivate, highlightedItem = _a.highlightedItem, expandedItem = _a.expandedItem, disabled = _a.disabled;
    // Hide the category title element from screen readers because it will be
    // provided as an ARIA label.
    return (React.createElement("li", { className: clsx(styles.category, disabled && styles.disabled), role: "presentation", "aria-disabled": disabled ? 'true' : undefined },
        item.text && (React.createElement("p", { className: clsx(styles.header, (_b = {}, _b[styles.disabled] = disabled, _b)), "aria-hidden": "true" }, item.text)),
        React.createElement("ul", { className: clsx(styles['items-list-container']), role: "group", "aria-label": item.text }, item.items && (React.createElement(ItemsList, { items: item.items, onItemActivate: onItemActivate, expandedItem: expandedItem, highlightedItem: highlightedItem, categoryDisabled: disabled, hasCategoryHeader: true })))));
};
export default CategoryElement;
//# sourceMappingURL=category-element.js.map